module.exports = __webpack_public_path__ + "images/1004453f15e5f445b906820690d60179-Visit Santa Barbara.png";